import { useMemo } from "react";

import type { ShareOfVoiceWidgetResponse } from "app/pages/activation/types/api";

import { useShareOfVoiceWidgetQuery } from "./useShareOfVoiceWidgetQuery";

type CompetitorsTrafficShareWidgetData = {
    shareOfVoiceData: ShareOfVoiceWidgetResponse | undefined;
    isLoading: boolean;
    isEmpty: boolean;
    hasTopics: boolean;
};

export const useCompetitorsTrafficShareWidgetData = (
    activationId: string,
    isMetadataLoading: boolean,
): CompetitorsTrafficShareWidgetData => {
    const {
        data: shareOfVoiceData,
        isLoading: isShareOfVoiceLoading,
        isFetching: isShareOfVoiceFetching,
    } = useShareOfVoiceWidgetQuery(activationId);

    const isEmpty =
        !isShareOfVoiceFetching && !isShareOfVoiceLoading && (shareOfVoiceData?.id === null || !shareOfVoiceData);

    const isLoading = isShareOfVoiceLoading || isMetadataLoading || isShareOfVoiceFetching;

    const hasTopics = useMemo(
        () => !!(shareOfVoiceData && (shareOfVoiceData.amountOfTopics ?? 0) > 0),
        [shareOfVoiceData],
    );

    return {
        shareOfVoiceData,
        isLoading,
        isEmpty,
        hasTopics,
    };
};
